export default "__VITE_ASSET__CiWMLXIE__"